import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  TextField, InputAdornment, Dialog, DialogTitle, DialogContent, DialogActions, FormGroup, Checkbox, FormControlLabel,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Query } from 'react-apollo';
import './styles/dialog.scss';
import { GET_SST_DATA } from './queries/dialog.queries';

const DATA_POLL_INTERVAL = 10000;

const ShowEnergyDataDialog = props => {
    const { source, open, onClose } = props;
    let allSSTs = [];

    if(open) {
      source.crosssections.forEach(crosssection => {
        crosssection.ssts.forEach(sst => {
          allSSTs.push(sst);
        });
      });
    }

    const handleClose = () => {
      onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md">
          <DialogTitle>
            Aktueller Energiestatus
          </DialogTitle>

          <DialogContent>
            <Table size="medium" className="energyDataTable">
              <TableHead>
                <TableRow>
                  <TableCell>Streckenstation</TableCell>
                  <TableCell>Akkuspannung</TableCell>
                  <TableCell>Verbrauch</TableCell>
                  <TableCell>Solarenergie</TableCell>
                  <TableCell>Ladeleistung</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                {allSSTs.map(sst => (
                  <Query query={GET_SST_DATA} variables={{id: sst.id}} pollInterval={DATA_POLL_INTERVAL} fetchPolicy="network-only">
                    {({ data, error, loading }) => {
                            
                      if (data !== undefined && data.sst !== undefined) {
                        if (data.sst.solar_controller_data === undefined || data.sst.solar_controller_data === null) {
                          return null;
                        }
                        let energyData = data.sst.solar_controller_data;
                        let battery_voltage = energyData.battery_voltage_slow_filter;
						            let loadPower = (energyData.load_voltage * energyData.load_current).toFixed(2);                     
						            let solarPower = (energyData.array_voltage * energyData.array_current).toFixed(2);                     
                        let chargingPower = (solarPower - loadPower).toFixed(2);
                        let status = (battery_voltage > 600 ? "nok" : "ok");                     
                        return  (
                          <TableRow key={sst.name}>
                            <TableCell component="th" scope="row">
                              {sst.name}
                            </TableCell>                        
                            <TableCell>{status == "nok" ? " " : battery_voltage + " V"}</TableCell>
                            <TableCell>{status == "nok" ? " " : (loadPower + " W")}</TableCell>
                            <TableCell>{status == "nok" ? " " : (solarPower <= 0 ? "-" : solarPower + " W")}</TableCell>
                            <TableCell>{status == "nok" ? " " : (chargingPower < 0 ? "-" : chargingPower + " W")}</TableCell>
                          </TableRow>
                        );
                      }
                      return null;
                      }}
                  </Query>
                ))}

              </TableBody>
            </Table>
            
          </DialogContent>

          <DialogActions>
            <Button color="primary" onClick={handleClose}>Verlassen</Button>       
          </DialogActions>
        </Dialog>
  );
};

ShowEnergyDataDialog.propTypes = {
  source: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onVerifyClick: PropTypes.func.isRequired
};

export default ShowEnergyDataDialog;